import _AgentsService from "../services/agent-service";
import { IAgentService } from "../types/services/agents-service";

const AgentsService: IAgentService = new _AgentsService();

export default AgentsService;
